import { render, staticRenderFns } from "./TaxLicense.vue?vue&type=template&id=1db6b7a6"
import script from "./TaxLicense.vue?vue&type=script&lang=js"
export * from "./TaxLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports